import MeEmpty from '@/components/MeEmpty'
import styles from './index.module.less'
interface IProps {
  activeValue: string
  moduleTransitionCheckinTab: 'hub' | 'rollapp_checkin'
}
const ModuleTransitionCheckin = ({ activeValue, moduleTransitionCheckinTab }: IProps) => {
  return (
    <>
      {activeValue === '1' && moduleTransitionCheckinTab === 'rollapp_checkin' && (
        <div className={styles.moduleTransitionCheckin}>
          <MeEmpty />
        </div>
      )}
    </>
  )
}

export default ModuleTransitionCheckin
